import { render, staticRenderFns } from "./sequence-review-associate-steps.vue?vue&type=template&id=ddc62804&scoped=true&"
import script from "./sequence-review-associate-steps.vue?vue&type=script&lang=js&"
export * from "./sequence-review-associate-steps.vue?vue&type=script&lang=js&"
import style0 from "./sequence-review-associate-steps.vue?vue&type=style&index=0&id=ddc62804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc62804",
  null
  
)

export default component.exports